// image-processing-loader
var previousRequest = require("!!../../../../../node_modules/fox-file-loader/index.js!../../../../../node_modules/file-loader/index.js?name=[path][name].[ext]!./banner-cam-shadow.png");
var dir = previousRequest.replace("banner-cam-shadow.png", "")
module.exports = require("!../../../../../node_modules/fox-image-optimize-plugin/router.js")({
	dir: dir,
	base: "banner-cam-shadow.png",
	name: "banner-cam-shadow",
	ext: ".png",
	query: ""
}, previousRequest);


//////////////////
// WEBPACK FOOTER
// ./images/banner-cam-shadow.png
// module id = 986
// module chunks = 4